import React, { Component, Fragment } from "react";
import $ from "jquery";
import "jquery-ui";
import "jquery-ui-dist/jquery-ui";
import ReactDOM from "react-dom";
import DragItem from "../model/DragItem";
window.jQuery = $;
require("jquery-ui/ui/widgets/mouse");
require("jquery-ui-touch-punch");
class DragItemUI extends Component {
  state = {
    isSelected: false,
  };

  componentDidMount = () => {
    window.x(this.itemToDrag);

    let { quizViewer, dragItem, activity } = this.props;
    let { quizViwerModel } = quizViewer.state;

    let click = {
      x: 0,
      y: 0,
    };
    $(ReactDOM.findDOMNode(this.itemToDrag)).draggable({
      revert: true,
      start: (event) => {
        activity.currentDragItem = new DragItem();
        activity.currentDragItem.initFromJson(dragItem.getAsJson());
        activity.currentDragItemHtml = this.itemToDrag;
        // console.log("start drag :")
        // console.log(activity.currentDragItem)
        // console.log()
        quizViewer.setState({ quizViwerModel });
        click.x = event.clientX;
        click.y = event.clientY;
        this.setState({ isSelected: false });
      },
      drag: (event, ui) => {
        this.setState({ isSelected: true });
        // This is the parameter for scale()
        // let zoom = quizViwerModel.factor
        // let original = ui.originalPosition;
        // // jQuery will simply use the same object we alter here
        // ui.position = {
        //     left: (event.clientX - click.x + original.left) / zoom,
        //     top: (event.clientY - click.y + original.top) / zoom
        // };
      },
      stop: () => {
        // this.setState({ isSelected: false });
        // console.log("stop drag :");
        // console.log(activity.currentDragItem);
        // console.log()
      },
    });
  };

  componentDidUpdate = () => {
    if (this.dragItemUIRef != null) window.x(this.dragItemUIRef);
  };

  render = () => {
    let { dragItem } = this.props;

    return <Fragment>{this.getDragItemUI(dragItem)}</Fragment>;
  };
  // /className="item-shape btn btn-outline-secondary "

  getDragItemUI = (dragItem) => {
    let { activity, quizViewer } = this.props;
    let { dragContainerModel } = activity;
    let { selectedStyle } = dragContainerModel;
    let { quizViwerModel } = quizViewer.state;

    if (dragItem.dragItemType == dragItem.TXT_TYPE)
      return (
        <div
          ref={(el) => (this.dragItemUIRef = el)}
          style={{
            minWidth: "100px",
            // height: "77px",

            border: this.state.isSelected ? "1px solid #fff" : "1px solid #000",
          }}
        >
          <table style={{ width: "100%", height: "100%" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                    background: "white",
                    minHeight: "65px",
                  }}
                >
                  <span
                    ref={(el) => (this.itemToDrag = el)}
                    dangerouslySetInnerHTML={{ __html: dragItem.dragTxt }}
                  ></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    else {
      return (
        <div
          ref={(el) => (this.dragItemUIRef = el)}
          className="card card-body"
          style={{
            minHeight: "100px",
            minWidth: "100px",
            border: this.state.isSelected ? "1px solid #fff" : "1px solid #000",
          }}
        >
          <img
            ref={(el) => (this.itemToDrag = el)}
            style={{ width: "100px" }}
            src={activity.imgUrl + dragItem.dragImgUrl}
          />
        </div>
      );
    }
  };
}

export default DragItemUI;
